import {
  getFavoriteActivities,
  getPremiumActivitiesCount,
} from "domain/activities/activities.actions";
import { getCarouselSlides } from "domain/carousel/carousel.actions";
import { getFolders } from "domain/folders/folders.actions";
import {
  getFavoritesSeances,
  getRandomSeance,
} from "domain/seances/seances.actions";
import { store } from "domain/store";
import {
  getFavoritesTechniques,
  getPauses,
  getRandomTechnique,
} from "domain/techniques/techniques.actions";
import {
  getFavoritesTutorials,
  getRandomTutorial,
} from "domain/tutorials/tutorials.actions";
import {
  getFavoritesVisualSupports,
  getRandomVisualSupport,
} from "domain/visual-supports/visual-supports.actions";
import { redirect } from "react-router-dom";
import { prepareAuth } from "ui/navigation/loaders/prepareAuth";
import { getSessionOnBoardingValues } from "ui/utils/on-boarding-storage";

export async function homeLoader() {
  const { userIsConnected } = await prepareAuth();
  if (!userIsConnected) {
    return redirect("/auth");
  }
  const userId = store.getState().auth.userInfos.id;
  getSessionOnBoardingValues(userId, store.dispatch);

  //get all inniz premium activities count for non premium banner
  await store.dispatch(getPremiumActivitiesCount());

  const resultRandomTechnique = await store
    .dispatch(getRandomTechnique())
    .unwrap();
  const resultRandomSeance = await store.dispatch(getRandomSeance()).unwrap();
  const resultRandomTutorial = await store
    .dispatch(getRandomTutorial())
    .unwrap();
  const resultRandomVisualSupport = await store
    .dispatch(getRandomVisualSupport())
    .unwrap();

  const resultCarousel = await store.dispatch(getCarouselSlides()).unwrap();
  const resultFavorites = await store
    .dispatch(getFavoriteActivities())
    .unwrap();

  //try to get data again if it failed
  setTimeout(() => {
    if (!resultRandomTechnique.success) {
      store.dispatch(getRandomTechnique());
    }
    if (!resultRandomSeance.success) {
      store.dispatch(getRandomSeance());
    }
    if (!resultRandomTutorial.success) {
      store.dispatch(getRandomTutorial());
    }
    if (!resultRandomVisualSupport.success) {
      store.dispatch(getRandomVisualSupport());
    }
    if (!resultCarousel.success) {
      store.dispatch(getCarouselSlides());
    }
    if (!resultFavorites.success) {
      store.dispatch(getFavoriteActivities());
    }
  }, 1000);

  return null;
}

export async function techniquesLoader() {
  const { userIsConnected } = await prepareAuth();
  if (!userIsConnected) {
    return redirect("/auth");
  }
  const userId = store.getState().auth.userInfos.id;
  getSessionOnBoardingValues(userId, store.dispatch);

  store.dispatch(getFavoriteActivities());

  return null;
}

export async function seancesLoader() {
  const { userIsConnected } = await prepareAuth();
  if (!userIsConnected) {
    return redirect("/auth");
  }
  const userId = store.getState().auth.userInfos.id;
  getSessionOnBoardingValues(userId, store.dispatch);

  store.dispatch(getFavoriteActivities());

  return null;
}

export async function createSeanceLoader() {
  const { userIsConnected } = await prepareAuth();
  if (!userIsConnected) {
    return redirect("/auth");
  }
  const userId = store.getState().auth.userInfos.id;
  getSessionOnBoardingValues(userId, store.dispatch);

  store.dispatch(getPauses());
  return null;
}

export async function myCreationsLoader() {
  const { userIsConnected } = await prepareAuth();
  if (!userIsConnected) {
    return redirect("/auth");
  }
  const userId = store.getState().auth.userInfos.id;
  getSessionOnBoardingValues(userId, store.dispatch);

  store.dispatch(getFavoriteActivities());
  store.dispatch(getFolders());

  return null;
}

export async function accountLoader() {
  const { userIsConnected } = await prepareAuth();
  if (!userIsConnected) {
    return redirect("/auth");
  }
  const userId = store.getState().auth.userInfos.id;
  getSessionOnBoardingValues(userId, store.dispatch);

  return null;
}

export async function favoritesLoader() {
  const { userIsConnected } = await prepareAuth();
  if (!userIsConnected) {
    return redirect("/auth");
  }
  const userId = store.getState().auth.userInfos.id;
  getSessionOnBoardingValues(userId, store.dispatch);

  const result = await store.dispatch(getFavoriteActivities()).unwrap();
  if (result.success) {
    const techniqueIds: number[] = [];
    const seanceIds: number[] = [];
    const tutorialIds: number[] = [];
    const supportIds: number[] = [];
    result.activities.forEach((a) => {
      if (a.type === "technique") techniqueIds.push(a.techniqueId);
      else if (a.type === "seance") seanceIds.push(a.seanceId);
      else if (a.type === "tutorial") tutorialIds.push(a.tutorialId);
      else if (a.type === "visuel") supportIds.push(a.visuelId);
    });
    store.dispatch(getFavoritesTechniques(techniqueIds));
    store.dispatch(getFavoritesSeances(seanceIds));
    store.dispatch(getFavoritesTutorials(tutorialIds));
    store.dispatch(getFavoritesVisualSupports(supportIds));
  }
  return null;
}

export async function changePersonalInfosLoader() {
  const { userIsConnected } = await prepareAuth();
  if (!userIsConnected) {
    return redirect("/auth");
  }
  const userId = store.getState().auth.userInfos.id;
  getSessionOnBoardingValues(userId, store.dispatch);

  return null;
}

export async function tutorialsLoader() {
  const { userIsConnected } = await prepareAuth();
  if (!userIsConnected) {
    return redirect("/auth");
  }
  const userId = store.getState().auth.userInfos.id;
  getSessionOnBoardingValues(userId, store.dispatch);

  store.dispatch(getFavoriteActivities());

  return null;
}

export async function visualSupportsLoader() {
  const { userIsConnected } = await prepareAuth();
  if (!userIsConnected) {
    return redirect("/auth");
  }
  const userId = store.getState().auth.userInfos.id;
  getSessionOnBoardingValues(userId, store.dispatch);

  store.dispatch(getFavoriteActivities());

  return null;
}

export async function contactLoader() {
  const { userIsConnected } = await prepareAuth();
  if (!userIsConnected) {
    return redirect("/auth");
  }
  const userId = store.getState().auth.userInfos.id;
  getSessionOnBoardingValues(userId, store.dispatch);

  store.dispatch(getFavoriteActivities());

  return null;
}
